import React from "react";
import config from "../config";

const TabSelect = ({
    options,
    selected,
	setSelected,
}) => {
    const { texts } = config || {};
    const handleClick = (event) => {
        setSelected([event.target.dataset.value]);
    }
    if (options instanceof Object) {
		options = Object.values(options);
	}
    return (
        <div className="em-block-open-position-feed__filters-desktop">
            {[
            <button key="all" className={!selected[0] ? 'active': null} data-value="" onClick={() => setSelected([])}>{texts.themes.all}</button>,
            (options && options.map((option) => {
                return (
                    <button key={option.id} href='' className={selected[0] == option.id ? 'active': null} data-value={option.id} onClick={handleClick}>{option.name}</button>
                    )
                }))
            ]}
        </div>
    );
}

export default TabSelect;